import React, { useEffect, useRef, useState } from "react";
import { t } from "@/localization";

const { POWERED_BY } = require("./embedCodes.cjs");

// Web only. The frame the EventLive loader (evt.live/embed.js) builds for the
// script code: `src` asks the page to fit (?fit=1) and the frame follows the
// height it reports, so the preview shows the whole embed without scrolling.
// Scripts don't run in innerHTML, so the preview can't use the loader itself.
const EmbedPreview = ({ src }) => {
  const frame = useRef(null);
  const [height, setHeight] = useState(null);

  useEffect(() => {
    const origin = new URL(src).origin;
    const onMessage = (event) => {
      const data = event.data;
      if (event.origin !== origin || !data || data.eventlive !== "height")
        return;
      if (!frame.current || event.source !== frame.current.contentWindow)
        return;
      const reported = Math.round(Number(data.height));
      if (reported > 0 && reported < 100000) setHeight(reported);
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [src]);

  return (
    <div>
      <iframe
        ref={frame}
        src={src}
        title={t("EventLive event")}
        allow="autoplay; fullscreen; payment"
        allowFullScreen
        allowtransparency="true"
        frameBorder="0"
        style={{
          display: "block",
          width: "100%",
          border: 0,
          // 16:9 until the page reports its height, as the loader does.
          ...(height ? { height } : { aspectRatio: "16 / 9" }),
        }}
      />
      <div dangerouslySetInnerHTML={{ __html: POWERED_BY }} />
    </div>
  );
};

export default EmbedPreview;
